import * as yup from 'yup';

/*
The validation rules are:
# Single row
 - requestDate is required only if afterHour or beforeHour is provided.
 - Completely empty row is allowed.
# Multiple rows
 - requestDate is required for every row, regardless of time.
*/

// Message is sent from json schema
const createServiceRequestRowSchema = messageFromSchema =>
  yup
    .object({
      requestDate: yup.string().nullable(),
      afterHour: yup.string().nullable(),
      beforeHour: yup.string().nullable(),
    })
    .test(
      'request-date-conditional',
      messageFromSchema,
      function rowTest(value) {
        if (!value) return true;

        const { requestDate, afterHour, beforeHour } = value;
        const hasTime = !!afterHour || !!beforeHour;

        const rowCount = this.options?.context?.rowCount ?? 1;

        // Single row
        if (rowCount === 1) {
          if (hasTime && !requestDate) {
            return this.createError({
              path: `${this.path}.requestDate`,
              message: messageFromSchema,
            });
          }
          return true;
        }

        // Multiple rows → every row needs date
        if (!requestDate) {
          return this.createError({
            path: `${this.path}.requestDate`,
            message: messageFromSchema,
          });
        }

        return true;
      },
    );

export default createServiceRequestRowSchema;
